export default {
  oAuthClientId: 1,
  oAuthClientSecret: "kdTTLYL5teB1LBqzuSpfE58YUahn1QGF49Nj7vNL"
};
